import styled from "styled-components";

export const GermanyRealityCheckDialogBox = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: ${props => props.theme.colors.textMiddleDark};
    font-size: 1.4rem;
`